import { Link } from "@tanstack/react-router";
import { LogIn } from "lucide-react";

interface SignInToSaveProps {
  /** In-app path to return to after signing in, e.g. "/f1-fantasy/apex-team". */
  redirectUrl: string;
  /** Headline, e.g. "Sign in free to save your team". */
  title: string;
  /** Supporting line explaining the benefit. */
  description: string;
  /** Button label, e.g. "Sign in". */
  ctaLabel: string;
}

/**
 * Banner prompting anonymous users to sign in so their data can be saved
 * locally (vault). Rendered by tools wherever a save feature is gated.
 */
export function SignInToSave({
  redirectUrl,
  title,
  description,
  ctaLabel,
}: SignInToSaveProps) {
  return (
    <div className="flex items-center gap-3 p-4 rounded-xl border border-primary/30 bg-primary/5">
      <LogIn className="h-5 w-5 text-primary shrink-0" aria-hidden="true" />
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium text-foreground">{title}</p>
        <p className="text-xs text-muted-foreground mt-0.5">{description}</p>
      </div>
      <Link
        to="/login"
        search={{ redirectUrl }}
        className="shrink-0 px-3 py-2 rounded-lg bg-primary text-primary-foreground text-sm font-medium hover:brightness-110 transition-all"
      >
        {ctaLabel}
      </Link>
    </div>
  );
}
